module.exports = __webpack_public_path__ + "img/campaign_modal_icon.bc2e38c1.png";